import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Shop {
	shopInfo: string;
	optInfo: string;
	shopSeq: string;
	shopNm: string;
	shopPlace: string;
	shopTm: string;
	refundNote: string;
}

interface Option {
	title: string;
	intro: string;
	useTm: string;
	cost: string;
	note: string;
	imageUrl: string;
	waitingSche: string /* 대기일정 */;
	waitingArea: string /* 대기장소 */;
	accompanyYn: string /* 동행여부 */;
}

interface OptionTrip {
	shopInfo: string;
	optInfo: string;
	shopSeq: string;
	shopNm: string;
	shopPlace: string;
	shopTm: string;
	refundNote: string;
}

interface OptionalTourDetail {
	shopList: Array<Shop>;
	optionList: Array<Option>;
	optionalTourInfo: OptionTrip;
}

/** ```
 * 선택관광/쇼핑
 *   `/pkg/event-schedule/{evCd}/optional-tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventOptionalTourDetail";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-schedule/${evCd}/optional-tour-detail`;
};

/** ```
 * 선택관광/쇼핑
 *   `/pkg/event-schedule/{evCd}/optional-tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventOptionalTourDetail = (
	evCd: string,
	options?: Partial<UseQueryOptions<Response<OptionalTourDetail>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		placeholderData: {body: {shopList: [], optionList: [], optionalTourInfo: null}},
		...options,
	});

export default useEventOptionalTourDetail;
export {getPath};
export type {Shop, Option, OptionTrip};
